import React, { useMemo } from "react";
import { Grid } from "@mui/material";
import DynamicFilterCst from "@components/DynamicFilterCst";
import { useAuth } from "@context/auth";
import { usePageFilters, PageFilterField } from "@hooks/usePageFilters";
import { DynamicFilterValue } from "@components/DynamicFilterCst/types";
import { FiltersBarProps, FiltersBarValue } from "./types";

const FiltersBarCst: React.FC<FiltersBarProps> = ({
  pageId,
  value,
  onChange,
  excludeKeys,
  onlyKeys,
  filterVisibility,
  dynamicOptions,
  optionsKeyOverrides,
}) => {
  const { user } = useAuth();
  const allFields = usePageFilters(pageId, user?.permissions, excludeKeys);

  const visibleFields = useMemo<PageFilterField[]>(() => {
    let result = allFields;
    if (onlyKeys && onlyKeys.length > 0) {
      result = result.filter((field) => onlyKeys.includes(field.key));
    }
    if (filterVisibility) {
      result = result.filter((field) => filterVisibility(field, value));
    }
    return result;
  }, [allFields, onlyKeys, filterVisibility, value]);

  const handleFieldChange = (key: string, nextValue: DynamicFilterValue) => {
    const next: FiltersBarValue = { ...value };
    if (nextValue === null || nextValue === "") {
      delete next[key];
    } else {
      next[key] = nextValue;
    }
    onChange(next);
  };

  if (visibleFields.length === 0) return null;

  return (
    <Grid container spacing={2}>
      {visibleFields.map((field) => (
        <Grid key={field.key} item xs={12} sm={6} md={4} lg={3}>
          <DynamicFilterCst
            field={field}
            value={value[field.key]}
            onChange={(next) => handleFieldChange(field.key, next)}
            options={dynamicOptions?.[field.key]}
            optionsKeyOverride={optionsKeyOverrides?.[field.key]}
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default FiltersBarCst;
